// 用户端考试相关 API 封装
import http from './http';
import { api } from '@/utils/api'; // 引入 utils/api 以确保兼容性

// 获取可报名考试列表（报名中）
export async function listActiveExams(params = {}) {
  const qs = new URLSearchParams();
  // 使用后端的 active 接口，该接口会过滤：
  // 1. 报名开始时间 <= 当前时间
  // 2. 报名结束时间 >= 当前时间 或 报名结束时间为空
  // 3. 状态为已发布(1)或进行中(2)
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') {
      qs.set(k, String(v));
    }
  });
  const queryString = qs.toString();
  const url = queryString ? `exam/exams/active/?${queryString}` : 'exam/exams/active/';
  const { data } = await http.get(url);
  return data;
}

// 获取已结束的考试列表（展示历史）
export async function listEndedExams(params = {}) {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') qs.set(k, String(v));
  });
  const { data } = await http.get(`exam/exams/ended/${qs.toString() ? '?' + qs.toString() : ''}`);
  return data;
}

// 分类列表（前台可见）
export async function listCategories() {
  try {
    const { data } = await http.get('exam/categories/');
    return Array.isArray(data) ? data : (data?.results || []);
  } catch (e) {
    return [];
  }
}

// 当前用户的报名申请列表
export async function listMyApplications() {
  const { data } = await http.get('exam/applications/my/');
  const list = Array.isArray(data) ? data : [];
  // 返回完整原始字段，并补充前端使用的便捷字段，避免丢失预填所需内容
  return list.map(item => ({
    // 保留后端返回的全部字段（含个人信息与附件）
    ...item,
    // 便捷字段供表格展示与状态判断使用
    exam_id: item?.exam?.id,
    exam_title: item?.exam?.title || '',
    audit_status: item?.status || 'pending',
    payment_status: item?.payment_status || 'unpaid',
    fee: item?.exam?.fee ?? null,
  }));
}

// 当前用户的成绩列表
export async function listMyScores(params = {}) {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') qs.set(k, String(v));
  });
  const { data } = await http.get(`exam/scores/my/${qs.toString() ? '?' + qs.toString() : ''}`);
  return Array.isArray(data) ? data : [];
}

// 当前用户的准考证列表（含下载/打印地址）
export async function listMyTickets() {
  const { data } = await http.get('exam/tickets/my/');
  return Array.isArray(data) ? data : [];
}

// 支付报名（审核通过后）
export async function payApplication(appId) {
  const { data } = await http.post(`exam/applications/${appId}/pay/`);
  return data;
}

// 创建微信Native下单，返回二维码地址等信息
export async function createWechatNativeOrder(appId) {
  const { data } = await http.post(`exam/applications/${appId}/wechat/native-order/`);
  return data;
}

// 取消报名（未缴费时）
export async function cancelApplication(appId) {
  const { data } = await http.post(`exam/applications/${appId}/cancel/`);
  return data;
}

// 获取考试详情
export async function getExamDetail(id) {
  if (!id) return null;
  const { data } = await http.get(`exam/exams/${id}/`);
  return data;
}

// 获取考试详情（用于报名页展示费用等信息）
export async function getExam(id) {
  if (!id && id !== 0) return null;
  const { data } = await http.get(`exam/exams/${id}/`);
  return data;
}

// 获取轮播图列表
export async function listCarousels() {
  try {
    // 使用 utils/api 直接请求，确保路径与原 Login.vue 一致，避免 baseURL 配置差异
    const data = await api.get('/api/admin/carousel/public/');
    return Array.isArray(data) ? data : (data?.results || []);
  } catch (e) {
    console.warn('获取轮播图失败，使用默认图', e);
    return [];
  }
}

// （保留上方的 payApplication/cancelApplication 实现，删除重复定义）
